import BaseApiAction from '@Actions/base-api-action';
import { Actions } from '@Context/common/general/context';

export default class ConsumeInvite extends BaseApiAction {
  runAction() {
    super.invokeCloudFunction({
      name: 'teams-consumeInvite',
      payload: {
        invite_id: this._payload.invite_id,
        action: this._payload.action
      },
    });
  }

  onSuccess(data) {
    this._dispatch({
      type: Actions.CoreActions.UpdateState,
      payload: {
        user: {
          groupInvites: this._state.user.groupInvites.filter((invite) => invite.doc_id !== this._payload.invite_id)
        },
      }
    })
    if(this._payload.action === 'ACCEPT') {
      this._dispatch({ type: Actions.UsersActions.GetAccountInfo })  
    }
    super.onSuccess(data);
  }
}
